import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { useLinkSocialMedia, useUpdateInfluencer } from "@entities/influencer";
import { useGetInfluencerFacets } from "@entities/influencer/lib/hooks/useGetFacets";
import { useGetInfluencer } from "@entities/influencer/lib/hooks/useGetInfluencerById";
import { useGetSocialMediaInfluencer } from "@entities/influencer/lib/hooks/useGetSocialMediaInfluencer";
import { InfluencerCard } from "@entities/influencer/ui/InfluencerCard";
import InfluencerUpdateForm from "@entities/influencer/ui/InfluencerUpdateForm";
import {
  IInfluencer,
  SocialMedia,
  SocialMediaInfluencerRequest
} from "@shared/lib/types/influencer";
import { Divider, Flex, Modal, Row, Space, Spin } from "antd";
import { useEffect, useRef, useState } from "react";

import { useGetInfluencerStore } from "@entities/discovery/lib/store/useGetInfluencerStore";
import { useGetSocialMediaInfluencerV2 } from "@entities/influencer/lib/hooks/useGetSocialMediaInfluencerV2";
import { SocialMediaForm } from "@entities/influencer/ui/SocialMedia/SocialMediaForm";
import { SocialMediaAIAnalysis } from "@features/SocialMediaAIAnalysis";
import { ToastService } from "@shared/lib/services";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import classNames from "classnames";
import { InfluencerDetails } from "./InfluencerDetails";
import { InsightsData } from "./Insights/InsightsData";
import styles from "./styles.module.scss";

interface Props {
  socialMediaInfluencerReq: SocialMediaInfluencerRequest;
  creatorInfo?: {
    name?: string;
    image?: string;
    username?: string;
  };
  handleRefetchInfluencer?: () => void;
}

export function SocialMediaInfluencerComp({
  socialMediaInfluencerReq,
  creatorInfo,
  handleRefetchInfluencer,
}: Props) {
  const { socialMediaInfluencer, isError, isFetching, refetch } =
    useGetSocialMediaInfluencer(socialMediaInfluencerReq);

  const [isInfluencerModalOpen, setInfluencerModalOpen] = useState(false);
  const { update, isUpdating, isUpdated } = useUpdateInfluencer();
  const { influencer, isFetching: isFetchingInfluencer } = useGetInfluencer(
    socialMediaInfluencer?.influencer?._id || ""
  );
  const firstRender = useRef(true);

  const [socialMediaModalOpen, setSocialMediaModalOpen] = useState(false);

  const [selectType, setselectType] = useState<
    { type: "influencer" } | { type: "socialMedia"; socialMediaId: string }
  >(() => {
    if (
      "socialMediaObjectId" in socialMediaInfluencerReq &&
      socialMediaInfluencerReq.socialMediaObjectId
    ) {
      return {
        type: "socialMedia",
        socialMediaId: socialMediaInfluencerReq.socialMediaObjectId,
      };
    }
    return { type: "influencer" };
  });

    const { socialMediaInfluencer: socialMediaInfluencerV2, isFetching: isFetchingV2, isError: isErrorV2, refetch: refetchV2 } =
    useGetSocialMediaInfluencerV2(selectType.type === "influencer" ? socialMediaInfluencer?.socialMedia?.[0]?._id || "" : selectType.socialMediaId);

  const { facets } = useGetInfluencerFacets();

  const { facets: facetsToDisplay } = useGetInfluencerStore();
  const categories = (facets?.category || [])?.map((item) => item._id) || [];

  const { isLinked, isLinking, linkSocialMedia } = useLinkSocialMedia();

  const handleAdd = (values: Partial<SocialMedia>) => {
    linkSocialMedia({
      influencerId: socialMediaInfluencer?.influencer?._id || "",
      socialMedia: { ...values } as SocialMedia,
    });
  };

  useEffect(() => {
    if (isLinked) {
      ToastService.success("Social Media Added");
      setSocialMediaModalOpen(false);
    }
  }, [isLinked]);

  useEffect(() => {
    if (firstRender.current && socialMediaInfluencer) {
      if (
        "socialMediaObjectId" in socialMediaInfluencerReq &&
        socialMediaInfluencerReq.socialMediaObjectId
      ) {
        setselectType({
          type: "socialMedia",
          socialMediaId: socialMediaInfluencerReq.socialMediaObjectId,
        });
      } else if (
        "username" in socialMediaInfluencerReq &&
        socialMediaInfluencerReq.username
      ) {
        if (socialMediaInfluencerReq.toOpenInfluencer) {
          setselectType({
            type: "influencer",
          });
        } else {
          setselectType({
            type: "socialMedia",
            socialMediaId:
              socialMediaInfluencer?.socialMedia.find(
                (item) =>
                  item.username ===
                    socialMediaInfluencerReq.username.socialMediaUsername &&
                  item.platform === socialMediaInfluencerReq.username.platform
              )?._id || "",
          });
        }
      } else {
        setselectType({
          type: "influencer",
        });
      }
      firstRender.current = false;
      return;
    }
  }, [socialMediaInfluencer, socialMediaInfluencerReq]);

  const handleSubmit = (influencerData: Partial<IInfluencer>) => {
    update({
      influencerId: socialMediaInfluencer?.influencer?._id || "",
      influencer: influencerData,
    });
    setInfluencerModalOpen(false);
  };

  useEffect(() => {
    if (isUpdated) {
      refetch();
    }
  }, [isUpdated]);

  useEffect(() => {
    return () => {
      if (handleRefetchInfluencer) {
        handleRefetchInfluencer();
      }
    };
  }, []);

  if (isError) {
    return <div>Error</div>;
  }

  if (isFetching || isFetchingInfluencer) {
    return (
      <Row justify="center" align="middle" style={{ height: "100%" }}>
        <Spin />
      </Row>
    );
  }

  if (
    !socialMediaInfluencer?.isInflunecerFound &&
    !socialMediaInfluencer?.isSocialMediaFound
  ) {
    return <div>Erorr State, Create</div>;
  }

  return (
    <Flex vertical gap={10}>
      <InfluencerCard
        isOnboarded={socialMediaInfluencer?.isInflunecerFound}
        handleEditClick={() => setInfluencerModalOpen(true)}
        influencer={influencer}
        creatorInfo={creatorInfo}
        isV2={true}
      />
      <Space className={styles.typeSelctor} size={12}>
        <div
          className={classNames(styles.selector, {
            [styles.selected]: selectType.type === "influencer",
          })}
          onClick={() => setselectType({ type: "influencer" })}
        >
          <UserOutlined size={18} />
        </div>
        <Divider type="vertical" style={{ margin: 0 }} />
        <Space wrap>
          {" "}
          {socialMediaInfluencer?.socialMedia?.map((item) => (
            <div
              className={classNames(styles.selector, {
                [styles.selected]:
                  selectType.type === "socialMedia" &&
                  selectType.socialMediaId === item._id,
              })}
              key={item._id}
              onClick={() =>
                setselectType({
                  type: "socialMedia",
                  socialMediaId: item?._id || "",
                })
              }
            >
              {getPlatformIcon(item.platform)}
              {item.username}
            </div>
          ))}
          <div
            className={classNames(styles.selector, styles.dashed)}
            onClick={() => setSocialMediaModalOpen(true)}
          >
            <PlusOutlined size={18} />
          </div>
        </Space>
      </Space>
      <Spin spinning={isFetchingV2}>
          <SocialMediaAIAnalysis socialMediaInfluencer={socialMediaInfluencerV2} />
        </Spin>
      {selectType.type === "influencer" && (
        <InfluencerDetails
          handleRefetch={refetch}
          influencer={influencer}
          socialMediaId={
            socialMediaInfluencer?.socialMedia?.length > 0
              ? socialMediaInfluencer?.socialMedia[0]?._id
              : ""
          }
          categoriesToDisplay={categories}
        />
      )}
      {selectType.type === "socialMedia" && (
        <InsightsData
          socialMediaId={selectType.socialMediaId}
          platform={
            socialMediaInfluencer?.socialMedia.find(
              (item) => item._id === selectType.socialMediaId
            )?.platform || "instagram"
          }
        />
      )}

      <Modal
        title="Update Influencer"
        open={isInfluencerModalOpen}
        onCancel={() => setInfluencerModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <InfluencerUpdateForm
          initialValues={influencer}
          isSubmitting={isUpdating}
          onSubmit={handleSubmit}
          initialCategories={categories}
        />
      </Modal>

      <Modal
        title="Add Social Media"
        open={socialMediaModalOpen}
        onCancel={() => setSocialMediaModalOpen(false)}
        footer={null}
        destroyOnClose
        width={700}
      >
        <SocialMediaForm
          handleAdd={handleAdd}
          isAdding={isLinking}
          socialMediasToDisplay={(facetsToDisplay["platforms"] || [])?.map(
            (item) => item._id
          )}
        />
      </Modal>
    </Flex>
  );
}
